
import { useRef, useEffect } from "react";
import { useLanguage } from "@/contexts/LanguageContext";

const AboutSection = () => {
  const sectionRef = useRef<HTMLElement>(null);
  const { t } = useLanguage();

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("revealed");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 }
    );

    const elementsToObserve = sectionRef.current?.querySelectorAll(".reveal-on-scroll");
    elementsToObserve?.forEach((el) => {
      observer.observe(el);
    });

    return () => {
      elementsToObserve?.forEach((el) => {
        observer.unobserve(el);
      });
    };
  }, []);

  return (
    <section ref={sectionRef} id="about" className="py-20 bg-white dark:bg-gray-900 transition-colors duration-300">
      <div className="container mx-auto px-6">
        <h2 className="text-3xl md:text-4xl font-bold mb-12 text-center reveal-on-scroll dark:text-gray-50">
          {t('about_title')}
        </h2>
        
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div className="reveal-on-scroll order-1 md:order-1">
            <div className="rounded-2xl overflow-hidden shadow-lg">
              <img 
                src="https://images.unsplash.com/photo-1469474968028-56623f02e42e" 
                alt="About Us" 
                className="w-full h-auto object-cover aspect-video"
                loading="lazy"
              />
            </div>
          </div>
          
          <div className="space-y-6 reveal-on-scroll order-2 md:order-2">
            <p className="text-gray-700 dark:text-gray-300">
              {t('about_text1')}
            </p>
            <p className="text-gray-700 dark:text-gray-300">
              {t('about_text2')}
            </p>
            <p className="text-gray-700 dark:text-gray-300">
              {t('about_text3')}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
